import React, { useState } from 'react';

interface AddReviewModalProps {
  onClose: () => void;
  onSubmit: (review: any) => void;
}

const AddReviewModal: React.FC<AddReviewModalProps> = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    source: '',
    rating: 5,
    title: '',
    review: '',
    reviewer_name: '',
    verified_purchase: false,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      timestamp: new Date().toISOString(),
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value,
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New Review</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="review-form">
          <div className="form-group">
            <label htmlFor="source">Source *</label>
            <input
              id="source"
              name="source"
              type="text"
              value={formData.source}
              onChange={handleChange}
              placeholder="e.g., Amazon, Google, Yelp"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="rating">Rating *</label>
            <select
              id="rating"
              name="rating"
              value={formData.rating}
              onChange={handleChange}
              required
            >
              <option value={5}>5 Stars</option>
              <option value={4}>4 Stars</option>
              <option value={3}>3 Stars</option>
              <option value={2}>2 Stars</option>
              <option value={1}>1 Star</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="title">Review Title</label>
            <input
              id="title"
              name="title"
              type="text"
              value={formData.title}
              onChange={handleChange}
              placeholder="Optional review title"
            />
          </div>

          <div className="form-group">
            <label htmlFor="review">Review Text *</label>
            <textarea
              id="review"
              name="review"
              value={formData.review}
              onChange={handleChange}
              placeholder="Enter the review content..."
              rows={6}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="reviewer_name">Reviewer Name</label>
            <input
              id="reviewer_name"
              name="reviewer_name"
              type="text"
              value={formData.reviewer_name}
              onChange={handleChange}
              placeholder="Optional reviewer name"
            />
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                name="verified_purchase"
                type="checkbox"
                checked={formData.verified_purchase}
                onChange={handleChange}
              />
              Verified Purchase
            </label>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Add Review
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddReviewModal;